import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { 
    createConfig, 
    getAllConfigs, 
    getConfigById, 
    updateConfig, 
    deleteConfig 
} from "../api/appConfigs";

// Query keys
export const configKeys = {
    all: ['configs'],
    lists: () => [...configKeys.all, 'list'],
    list: (filters) => [...configKeys.lists(), { filters }],
    details: () => [...configKeys.all, 'detail'],
    detail: (id) => [...configKeys.details(), id],
};

// Get all configs
export const useGetAllConfigs = (filters = {}) => {
    return useQuery({
        queryKey: configKeys.list(filters),
        queryFn: () => getAllConfigs(filters),
        staleTime: 1000 * 60 * 5, // 5 minutes
    });
};

// Get config by ID
export const useGetConfigById = (id) => {
    return useQuery({
        queryKey: configKeys.detail(id),
        queryFn: () => getConfigById(id),
        enabled: !!id,
    });
};

// Create config
export const useCreateConfig = () => {
    const queryClient = useQueryClient();
    
    return useMutation({
        mutationFn: createConfig,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: configKeys.lists() });
        },
    });
};

// Update config
export const useUpdateConfig = () => {
    const queryClient = useQueryClient();
    
    return useMutation({
        mutationFn: updateConfig,
        onSuccess: (data, variables) => {
            queryClient.invalidateQueries({ queryKey: configKeys.lists() });
            queryClient.invalidateQueries({ queryKey: configKeys.detail(variables.id) });
        },
    });
};

// Delete config
export const useDeleteConfig = () => {
    const queryClient = useQueryClient();
    
    return useMutation({
        mutationFn: deleteConfig,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: configKeys.lists() });
        },
    });
};
